import { Show } from "solid-js";
import { AnimatedNumber } from "./AnimatedNumber.tsx";

export function MetricCard(props: {
  label: string;
  value: number | undefined;
  unit?: string;
  digits?: number;
  large?: boolean;
}) {
  return (
    <div class="metric-inset px-3 py-2.5">
      <div class="font-mono text-[9px] font-medium uppercase tracking-[0.15em] text-[var(--color-text-secondary)]">
        {props.label}
      </div>
      <div class="mt-1.5 flex items-baseline gap-1.5">
        <Show
          when={props.value !== undefined}
          fallback={
            <span class="font-mono text-lg text-[var(--color-text-dim)] animate-data-pulse">
              —
            </span>
          }
        >
          <AnimatedNumber
            value={props.value!}
            digits={props.digits ?? 0}
            large={props.large}
          />
          {props.unit && (
            <span class="font-mono text-[10px] font-medium uppercase tracking-wider text-[var(--color-text-secondary)]">
              {props.unit}
            </span>
          )}
        </Show>
      </div>
    </div>
  );
}
